export const myOrdersId = `my-account-orders`
export const myAccountInfoId = `my-account-info`
export const myInsuranceId = `my-account-insurance`
export const myResupplyId = `my-account-resupply`
export const myEquipmentId = `my-account-equipment`
export const myPhysicianId = `my-account-physician`
export const myInvoiceId = `my-account-invoice`
